;(function (angular) {
  'use strict'

  angular.module('kilo.routes.subcontractor', [
    'kilo.routes.subcontractor.list'
  ])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    const parentState = {
      name: 'subcontractor',
      url: '/subcontractor',
      abstract: true
    }
    $stateProvider.state(parentState)
  }
})(window.angular)
